// Product identity — name and tagline are never separated in user-facing copy
// (CLAUDE.md "Product Identity"). Render them together via <Wordmark/>.
export const PRODUCT_NAME = 'Proof of Work'
export const TAGLINE = 'Your record of professional impact'
